/**
 * Sends selectionGraphic messages to CommunicationStore based on current selection state.
 */

import { useEffect } from "react";
import { messageIds, selectionFrom } from "../constants";

export default function useSelectionGraphicMessaging({
  CommunicationStore,
  graphic,
  selectedEntity,
  source,
  previousFrom,
}) {
  useEffect(() => {
    if (!CommunicationStore?.addMessage) return;

    // Always send message when graphic, selectedEntity, or source changes
    // This ensures RasterStatistics receives timely updates
    if (graphic || previousFrom === selectionFrom.zoomToGeo) {
      CommunicationStore.addMessage({
        to: messageIds.selectionGraphic,
        message: {
          graphic,
          entity: selectedEntity,
          source: source
            ? {
                name: source.Name,
                displayAttribute: "displayLabel",
                displayText: source.Name,
              }
            : null,
          from: selectionFrom.zoomToGeo,
        },
      });
    }
  }, [CommunicationStore, graphic, selectedEntity, source, previousFrom]);
}
